import React, { useEffect, useRef, useLayoutEffect, useState } from "react";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { useSelector } from "react-redux";
import styles from "./category.module.css";
import SubCategory from "./SubCategory";

/// static filters check for categories to show
const statCatCheck = ["club", "league", "tournament"];

const Index = ({
  filter,
  setFilter,
  categories,
  childFilter,
  setChildFilter,
  setSubFilter,
  subFilter,
  page,
  home,
  filterOn,
}) => {
  const goalCategories = useSelector((state) => state.goalCategories);
  const loggedUser = useSelector((state) => state.loggedUser.user);

  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [showChildCat, setShowChildCat] = useState(false);
  const [currentCat, setCurrentCat] = useState(null);
  const [currentSubCat, setCurrentSubCat] = useState(null);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  const scroll = (direction) => {
    scrollRef.current.scrollBy({
      left: direction === "left" ? -200 : 200,
      behavior: "smooth",
    });
  };

  useLayoutEffect(() => {
    checkScroll();
  }, [goalCategories.data?.data?.length]);

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  useEffect(() => {
    if (filter == "") {
      // setFilter("");
      setCurrentSubCat(null);
      // setChildFilter(null);

      // setSubFilter(null);
      setCurrentCat(null);
    } else {
      setCurrentCat(() => categories?.find((cat) => cat.id == filter) || "");
    }
  }, [filter]);

  return (
    <>
      <Box
        className={`${
          page == "MyAccount"
            ? styles.filter_container_Acc
            : styles.filter_container
        }`}
      >
        {showLeft && (
          <Button
            className={
              page == "leaderboard-admin"
                ? `${styles.scroll_arrow_admin} ${styles.left}`
                : `${styles.scroll_arrow} ${styles.left}`
            }
            onClick={() => scroll("left")}
          >
            ‹
          </Button>
        )}
        <Box className={`${styles.filter_wrapper}`} ref={scrollRef}>
          <Button
            onClick={() => {
              setFilter("");
              setCurrentSubCat(null);
              setChildFilter(null);

              setSubFilter(null);
              setCurrentCat(null);
            }}
            className={
              page == "MyAccount"
                ? filter == ""
                  ? `${styles.filter_Acc} ${styles.active}`
                  : `${styles.filter_Acc}`
                : page == "leaderboar-admin"
                  ? filter == ""
                    ? `${styles.filter_admin} ${styles.active}`
                    : `${styles.filter_admin}`
                  : filter == ""
                    ? `${styles.filter} ${styles.active}`
                    : `${styles.filter}`
            }
          >
            <Typography component="h1" className="text">
              All
            </Typography>
          </Button>
          {home == "home" ? (
            !loggedUser.device_id &&
            <Button
              onClick={() => {
                setFilter("AllClubs");
                setCurrentSubCat(null);
                setChildFilter(null);

                setSubFilter(null);
                setCurrentCat(null);
              }}
              className={
                page == "MyAccount"
                  ? filter == ""
                    ? `${styles.filter_Acc} ${styles.active}`
                    : `${styles.filter_Acc}`
                  : page == "leaderboar-admin"
                    ? filter == ""
                      ? `${styles.filter_admin} ${styles.active}`
                      : `${styles.filter_admin}`
                    : filter == "AllClubs"
                      ? `${styles.filter} ${styles.active}`
                      : `${styles.filter}`
              }
            >
              <Typography component="h1" className="text">
                Football Clubs
              </Typography>
            </Button>
          ) : null}
          {categories.map((cat, index) => (
            <Button
              key={index}
              onClick={() => {
                setFilter(cat.id);
                setCurrentSubCat(null);
                setChildFilter(null);

                setSubFilter(null);
                setCurrentCat(cat);
              }}
              className={
                page == "MyAccount"
                  ? filter == cat.id
                    ? `${styles.filter_Acc} ${styles.active}`
                    : `${styles.filter_Acc}`
                  : page == "leaderboard-admin"
                    ? filter == cat.id
                      ? `${styles.filter_admin} ${styles.active}`
                      : `${styles.filter_admin}`
                    : filter == cat.id
                      ? `${styles.filter} ${styles.active}`
                      : `${styles.filter}`
              }
            >
              <Typography component="h1" className="text">
                {cat.name}
              </Typography>
            </Button>
          ))}
        </Box>

        {showRight && (
          <Button
            className={
              page == "leaderboard-admin"
                ? `${styles.scroll_arrow_admin} ${styles.right}`
                : `${styles.scroll_arrow} ${styles.right}`
            }
            onClick={() => {
              scroll("right");
            }}
          >
            ›
          </Button>
        )}
      </Box>

      {currentCat?.subCategory ? (
        <>
          <Box
            className={""}
            sx={{ display: "flex", gap: "10px", padding: "0 5px" }}
          >
            {currentCat?.subCategory.map((cat, index) => (
              <SubCategory
                cat={cat}
                index={index}
                filter={filter}
                childFilter={childFilter}
                setChildFilter={setChildFilter}
                subCategory={currentCat?.subCategory}
                setSubFilter={setSubFilter}
                subFilter={subFilter}
                setCurrentSubCat={setCurrentSubCat}
                page={page}
              />
            ))}
          </Box>
        </>
      ) : null}

      {currentSubCat?.childSubCategories ? (
        <Box className={`${styles.sub_filter_container} ${styles.active}`}>
          {currentSubCat?.childSubCategories?.map((cat, index) => (
            <Button
              key={index}
              className={
                page == "MyAccount"
                  ? childFilter == cat.id
                    ? `${styles.sub_filter_Acc} ${styles.active}`
                    : `${styles.sub_filter_Acc}`
                  : page == "leaderboard-admin"
                    ? childFilter == cat.id
                      ? `${styles.sub_filter_admin} ${styles.active}`
                      : `${styles.sub_filter_admin}`
                    : childFilter == cat.id
                      ? `${styles.sub_filter} ${styles.active}`
                      : `${styles.sub_filter}`
              }
              onClick={() => {
                setChildFilter(cat.id);
              }}
            >
              <Typography component="h1" className="text">
                {cat.name}
              </Typography>
            </Button>
          ))}
        </Box>
      ) : null}
    </>
  );
};

export default Index;
